import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import keys from "../store/keys";
import { setKey, clearKeys, session, setStringifiedKey } from "../store/actions";
import { connect } from "react-redux";
import utils from '../utils/utils';
import adminService from '../services/admin';
import Cookies from 'universal-cookie';
import '../css/login.css'; // New Login Styles

function Login({
    session,
    setKey,
    setStringifiedKey,
    getKey,
    clearKeys,
    ...props
}) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [redirectTo, setRedirectTo] = useState(null);

    useEffect(() => {
        clearKeys();
    }, []);

    const handleSubmit = async e => {
        e.preventDefault();
        if (!email || email.length === 0) {
            setErrorMessage(t("email_required"));
            return;
        } else {
            if (!utils.isValidEmail(email)) {
                setErrorMessage(t("invalid_email"));
                return;
            }
        }
        if (!password || password.length === 0) {
            setErrorMessage(t("password_required"));
            return;
        }

        setKey(keys.isLoading, true);
        await adminService.login(email, password)
            .then(result => {
                if (result.error) {
                    setErrorMessage(result.error);
                    setKey(keys.isLoading, false);
                    return;
                }

                if (result.data) {
                    const data = result.data;
                    setErrorMessage('');
                    setSuccessMessage(t("login_success_redirect"));

                    const cookies = new Cookies();
                    if (rememberMe)
                        cookies.set(data.cookie, data.token, { path: '/', maxAge: data.age });
                    else
                        cookies.remove(data.cookie);

                    setKey(keys.token, data.token);
                    setKey(keys.isLoading, false);
                    setKey(keys.cookie, data.cookie);
                    setKey(keys.isLoggedIn, true);
                    setStringifiedKey(keys.user, data.user);
                    setKey(keys.showLogin, false);
                    setRedirectTo('/users');
                }
            });
    }

    if (!session.showLogin) return null;

    return (
        <div className="login-overlay">
            {redirectTo && <Redirect push to={redirectTo} />}

            <div className="login-card">
                <div className="login-header">
                    <img className="login-logo" src="/logofull.png" alt="Logo" />
                    <h2 className="login-title">{t("admin_access")}</h2>
                    <p className="login-subtitle">{t("sign_in_subtitle")}</p>
                </div>

                {errorMessage && <div className="login-alert login-alert-error">{errorMessage}</div>}
                {successMessage && <div className="login-alert login-alert-success">{successMessage}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group-modern">
                        <label className="form-label-modern" htmlFor="txtEmail">{t("email_address")}</label>
                        <input
                            type="text"
                            className="form-control-modern"
                            placeholder="name@company.com"
                            required
                            id="txtEmail"
                            value={email}
                            onChange={e => {
                                setEmail(e.target.value);
                                setErrorMessage('');
                            }}
                        />
                    </div>

                    <div className="form-group-modern">
                        <label className="form-label-modern" htmlFor="txtPassword">{t("password_label")}</label>
                        <input
                            type="password"
                            className="form-control-modern"
                            placeholder={t("password_placeholder")}
                            required
                            id="txtPassword"
                            value={password}
                            onChange={e => {
                                setPassword(e.target.value);
                                setErrorMessage('');
                            }}
                        />
                    </div>

                    <div className="remember-me-container">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="chkRememberMe"
                            checked={rememberMe}
                            onChange={e => setRememberMe(e.target.checked)}
                        />
                        <label className="remember-me-label" htmlFor="chkRememberMe">{t("keep_logged_in")}</label>
                    </div>

                    <button type="submit" className="btn-modern btn-primary-modern w-100" style={{ width: '100%' }}>
                        {t("sign_in")}
                    </button>

                    <div className="login-footer">
                        {t("forgot_password_q")}
                        <button
                            type="button"
                            className="btn-link-modern"
                            onClick={() => {
                                setKey(keys.showLogin, false);
                                setKey(keys.showResetPassword, true);
                            }}
                        >
                            {t("reset_here")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({
    session: store.session
});

const mapDispatchToProps = dispatch => ({
    setKey: (key, value) => dispatch(setKey(key, value)),
    clearKeys: () => dispatch(clearKeys()),
    setStringifiedKey: (key, value) => dispatch(setStringifiedKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);